<script lang="ts">
    import cn from 'classnames';
    import { IconName } from '@uikit/svg-icon';
    import { Tag, TagTypes } from '@uikit/tag';

    import { type Action, setActionFunc } from '@uikit/actions';

    import type { TagData } from './types';
    import s from './tag-set.module.css';

    export let items: NullableType<TagData[]> = undefined;
    export let addedItems: NullableType<TagData[]> = undefined;
    export let deletedItems: NullableType<TagData[]> = undefined;
    export let disabled: boolean = false;
    export let action: Action | undefined = undefined;

    $: ({ actionFunc, actionParams } = setActionFunc(action));
</script>

<div use:actionFunc={actionParams}>
    {#if items || addedItems}
        <div
            class={cn(s.list, { [s.separator]: deletedItems && deletedItems.length })}
            data-testid="tag-set-main-and-added-items"
        >
            {#if items}
                <span class={s.mainItems} data-testid="tag-set-main-items">
                    {#each items as { label, clickHandler, iconClickHandler }}
                        <Tag
                            {label}
                            iconRight={iconClickHandler && IconName.CloseSmall}
                            iconRightClickHandler={iconClickHandler && (() => iconClickHandler?.(label))}
                            {disabled}
                            clickHandler={clickHandler && (() => clickHandler?.(label))}
                        />
                    {/each}
                </span>
            {/if}
            {#if addedItems}
                <span class={s.addedItems} data-testid="tag-set-added-items">
                    {#each addedItems as { label, clickHandler, iconClickHandler }}
                        <Tag
                            {label}
                            color={TagTypes.Color.Secondary}
                            iconRight={iconClickHandler && IconName.CloseSmall}
                            iconRightClickHandler={iconClickHandler && (() => iconClickHandler?.(label))}
                            {disabled}
                            clickHandler={clickHandler && (() => clickHandler?.(label))}
                        />
                    {/each}
                </span>
            {/if}
        </div>
    {/if}
    {#if deletedItems && deletedItems.length > 0}
        <div class={cn(s.list, s.deletedItems)} data-testid="tag-set-deleted-items">
            {#each deletedItems as { label, clickHandler, iconClickHandler }}
                <Tag
                    {label}
                    strikethrough
                    iconRight={iconClickHandler && IconName.Plus}
                    iconRightClickHandler={iconClickHandler && (() => iconClickHandler?.(label))}
                    {disabled}
                    clickHandler={clickHandler && (() => clickHandler?.(label))}
                />
            {/each}
        </div>
    {/if}
</div>
